import { axios } from '@/utils/request'
// eslint-disable-next-line
import { BasicLayout, BlankLayout, PageView, RouteView } from '@/layouts'
import { sysInfo } from '@/config'
// 前端路由表
const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: BasicLayout,
  BlankLayout: BlankLayout,
  RouteView: RouteView,
  PageView: PageView,

  // 你需要动态引入的页面组件
  workplace: () => import('@/views/dashboard/Workplace'),
  dict: () => import('@/views/sysManagement/dict/List.vue'),
  menu: () => import('@/views/sysManagement/menu/List.vue'),
  group: () => import('@/views/sysManagement/group/list.vue'),
  role: () => import('@/views/sysManagement/role2/role.vue'),
  fps: () => import('@/views/fps/list.vue'), // 预览应用接入配置
  baseInfo: () => import('@/views/role/baseInfo/List.vue'), // 人员管理--基础信息管理
  designs: () => import('@/views/business/designs/List.vue'), // 商机管理--设计代表管理
  markets: () => import('@/views/business/markets/List.vue'), // 商机管理--市场管理
  proprietors: () => import('@/views/business/proprietors/List.vue'), // 商机管理--业主管理
  contract_1: () => import('@/views/business/contract_1/List.vue'), // 商机管理--合同管理
  projectList: () => import('@/views/project/projectList/List.vue'), // 项目管理--项目列表
  collection: () => import('@/views/business/collection/List.vue'), // 收付款管理
  invoice: () => import('@/views/business/invoice/List.vue'), // 发票管理
  contract: () => import('@/views/project/contract/tabs.vue'), // 项目管理--合同管理
  friendBusiness: () => import('@/views/project/friendBusiness/List.vue'), // 项目管理--友商库
  suppliers: () => import('@/views/project/supplier/List.vue'), // 项目管理-供应商管理
  datapermission: () => import('@/views/sysManagement/datapermission/treeList.vue'), // 系统管理-数据权限管理
  itemBank: () => import('@/views/train/itemBank/List.vue'), // 培训管理
  paper: () => import('@/views/train/paper/list.vue'), // 试卷管理
  productManager: () => import('@/views/productManager/product/list.vue'), // 试卷管理
  inquiry: () => import('@/views/inquiry/list.vue'), // 询价采购库
  applicant: () => import('@/views/role/applicant/list.vue'), // 应聘人员管理
  assessment: () => import('@/views/role/assessment/list.vue'), // 部门人员考核管理
  organizationalStructure: () => import('@/views/organizationalStructure/index.vue'), // 组织架构

  assetManagement: () => import('@/views/assetLedger/assetLedger.vue'), // 资产台账，杭氧
  sparePartsManagement: () => import('@/views/sparePartsManagement/sparePartsManagement.vue'), // 备件管理，杭氧
  equipmentLedger: () => import('@views/equipmentLedger/equipmentLedger.vue'), // 设备台账
  gasManagement: () => import('@views/gasManagement/gasManagement.vue'), // 气体管理
  gasEquipment: () => import('@views/gasEquipment/gasEquipment.vue'), // 气体设备
  fileManagement: () => import('@views/fileManagement/fileManagement.vue'), // 档案管理
  deviceParameter: () => import('@views/deviceParameter/deviceParameter.vue'), // 设备参数管理
  deviceType: () => import('@views/deviceType/deviceType.vue'), // 设备参数管理，
  relevant: () => import('@views/relevant/relevant.vue'), // sap归口部门配置
  equipmentParameters: () => import('@views/equipmentParameters/equipmentParameters.vue'), // 设备参数管理
  featureManagement: () => import('@views/featureManagement/featureManagement.vue'), // 设备特性管理
  gasEquipmentLedger: () => import('@views/gasEquipmentLedger/gasEquipmentLedger.vue'), // 气体设备台账
  centralizedManagement: () => import('@views/centralizedManagement/centralizedManagement.vue'), // 归口管理
  specialEquipmentLedger: () => import('@views/specialEquipmentLedger/specialEquipmentLedger.vue'), // 特种设备
  assetClassManagement: () => import('@views/assetClassManagement/assetClassManagement.vue'), // 资产分类管理
  assetHeadManage: () => import('@views/assetHeadManage/assetHeadManage.vue'), // 资产表头配置
  testView: () => import('@views/testView/testView.vue'), // 资产分类管理
  fieldManage: () => import('@/views/fieldManage/fieldManage'), // 字段库管理
  warehouseManagement: () => import('@/views/warehouseManagement/warehouseManagement'), // 仓库管理
  centralizedDeptManagement: () => import('@/views/centralizedDeptManagement/centralizedDeptManagement'), // 设备归口部门管理
  timingTask: () => import('@/views/timingTask/timingTask') // 定时任务
}

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
  path: '*', redirect: '/404', hidden: true
}

/**
 * 获取后端路由信息的 axios API
 * @returns {Promise}
 */
export const getRouterByUser = () => {
  return axios({
    url: sysInfo.apiRemote + '/auth/menu',
    method: 'get'
  })
  // return new Promise((resolve, reject) => {
  //   const res = require('../../public/data/test/menu.json')
  //   resolve(res)
  // })
}

/**
 * 获取路由菜单信息
 *
 * 1. 调用 getRouterByUser() 访问后端接口获得路由结构数组
 *    @see https://github.com/sendya/ant-design-pro-vue/blob/feature/dynamic-menu/public/dynamic-menu.json
 * 2. 调用
 * @returns {Promise<any>}
 */
export const generatorDynamicRouter = () => {
  const homePage = '/homePage'
  return new Promise((resolve, reject) => {
    // ajax
    getRouterByUser().then(res => {
      if (res.status === 0 && res.data) {
        var putPage = (arr) => {
          // debugger
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].children.length > 0) {
              arr[i] = {
                ...arr[i],
                component: 'RouteView'
              }
              arr[i].children = putPage(arr[i].children)
              arr = [...arr]
            }
          }
          return arr
        }
        var children = putPage(res.data)
        const result = [{
          title: '首页',
          key: '',
          name: 'index',
          component: 'BasicLayout',
          redirect: homePage,
          children: res.data ? children : []
        }]
        const routers = generator(result)
        routers.push(notFoundRouter)
        resolve(routers)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 格式化 后端 结构信息并递归生成层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap, parent) => {
  return routerMap.map(item => {
    const currentRouter = {
      // 路由地址 动态拼接生成如 /dashboard/workplace
      path: `${parent && parent.path || ''}/${item.key}`,
      // 路由名称，建议唯一
      name: `${item.name}/${item.key}` || item.key || '',
      // 该路由对应页面的 组件
      component: constantRouterComponents[item.component || item.key],
      hidden: item.isHidden === 1,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: { title: item.title, icon: item.icon || undefined, permission: item.key && [item.key] || null, keepAlive: item.isKeepAlive === 1, hiddenHeaderContent: false }
    }
    // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
    currentRouter.path = currentRouter.path.replace('//', '/')
    // 重定向
    item.redirect && (currentRouter.redirect = item.redirect)
    // 是否有子菜单，并递归处理
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter)
    }
    // console.log(currentRouter)
    // console.log('*******', item.component || item.key)
    // console.log('>>>>>>>>>', constantRouterComponents[item.component || item.key])
    return currentRouter
  })
}
